import type { TranslatorService } from "@app/services/translator";
import type { NapiDeparture } from "@app/types/napi-departures-types";

export const FAKE_MULTIPLE_OPERATORS_ID = "multiple-operators";

/**
 * @param departure Normal departure object or "fake" departure for interconnection
 * @returns
 */
export function isInterconnectionDeparture(departure: NapiDeparture): boolean {
  return !!departure.interconnection;
}

export function getGenericMultipleOperatorUDM(translator: TranslatorService): {
  "multiple-operators": {
    type: "mapped";
    id: "multiple-operators";
    profile_id: null;
    xid: "multiple-operators";
    name: string;
    display_name: string;
    logo_url: null;
    passenger_phone_required: boolean;
    passenger_address_required: boolean;
  };
} {
  const name = translator.t("!departure.interconnection.multiple-operators");

  return {
    [FAKE_MULTIPLE_OPERATORS_ID]: {
      type: "mapped",
      id: FAKE_MULTIPLE_OPERATORS_ID,
      xid: FAKE_MULTIPLE_OPERATORS_ID,
      profile_id: null,
      name,
      display_name: name,
      logo_url: null,
      passenger_phone_required: false,
      passenger_address_required: false
    }
  };
}
